import { useState, useEffect, useRef, useCallback } from 'react';
import './styles/luxe-mane.css';
import tapeIn from './tape in.jpg';
import weft from './weft.png';
import ktip from './ktip.jpg';
import itip from './itip.webp';
import clipIns from './clip ins.png';
import blowdry from './blowdry.png';
import haircut from './haircut.png';
import salon from './salon2.png';
import g1  from './gallery/1.png';
import g2  from './gallery/2.png';
import g3  from './gallery/3.png';
import g4  from './gallery/4.png';
import g5  from './gallery/5.png';
import g6  from './gallery/6.png';
import g7  from './gallery/7.png';
import g8  from './gallery/8.png';
import g9  from './gallery/9.png';
import g10 from './gallery/10.png';
import g11 from './gallery/11.png';
import g12 from './gallery/12.png';
import g13 from './gallery/13.png';
import g16 from './gallery/16.jpg';
import {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakToggle,
} from './tweaks-panel';

const THEMES = [
  { id: "blush", label: "Blush",      swatch: "#c98579" },
  { id: "mauve", label: "Mauve",      swatch: "#a87584" },
  { id: "champ", label: "Champagne",  swatch: "#a88c54" },
  { id: "pearl", label: "Pearl",      swatch: "#8e7b66" },
  { id: "noir",  label: "Noir",       swatch: "#d49a8c" },
];

const STUDIO = [
  { id: "wash", name: "Wash & Blow", img: blowdry,  desc: "Restorative cleanse, scalp care and a polished blowout to finish.", price: "$75 – $120+", time: "60 – 90 min" },
  { id: "cut",  name: "Haircut",     img: haircut,  desc: "A tailored trim or reshape designed to maintain integrity and elevate.", price: "$70 – $150+", time: "45 – 75 min" },
];

const EXTENSIONS = [
  { id: "tape", name: "Tape Ins",        img: tapeIn,  desc: "Lightweight, discreet, seamlessly blended.",          install: "$400 – $900+",  maint: "$150 – $300+" },
  { id: "weft", name: "Hand-Tied Weft",  img: weft,    desc: "Fuller volume with soft, natural movement.",          install: "$600 – $1,400+", maint: "$200 – $450+" },
  { id: "ktip", name: "K-Tips",          img: ktip,    desc: "Keratin bonds for long wear and versatile styling.",  install: "$900 – $2,000+", maint: "$200 – $500+" },
  { id: "itip", name: "I-Tips",          img: itip,    desc: "Reusable, strand-by-strand, with effortless flow.",   install: "$700 – $1,800+", maint: "$200 – $450+" },
  { id: "clip", name: "Clip Ins",        img: clipIns, desc: "Event-ready fullness without long-term commitment.",  install: "$60 – $150+",   maint: null },
];

const REVIEWS = [
  { quote: "I've had extensions before but nothing like this. You genuinely cannot tell where my hair ends.", initials: "M.R.", location: "Tribeca", method: "Tape Ins" },
  { quote: "She walked me through everything before starting. My hair felt just as healthy after as it did going in.", initials: "A.K.", location: "West Village", method: "Hand-Tied Weft" },
  { quote: "Obsessed. I've gotten so many compliments and nobody can believe they're extensions.", initials: "J.L.", location: "Brooklyn", method: "K-Tips" },
];

const GALLERY = [
  { label: "Tape ins",     img: g1  },
  { label: "Balayage",     img: g2  },
  { label: "Hand-tied",    img: g3  },
  { label: "Highlights",   img: g4  },
  { label: "K-tips",       img: g5  },
  { label: "Bond detail",  img: g6  },
  { label: "Curl finish",  img: g7  },
  { label: "Bead app.",    img: g8  },
  { label: "Wave styling", img: g9  },
  { label: "Tape detail",  img: g10 },
  { label: "Weft part",    img: g11 },
  { label: "Blowout",      img: g12 },
  { label: "K-tips",       img: g13 },
  { label: "Finish",       img: g16 },
];

const DEFAULTS = {
  theme: "blush",
  italicAccents: true,
  rotatingStamp: true,
  ribbon: true,
  lockTheme: true,
};

const leadStyle = {
  fontFamily: 'var(--font-body)',
  fontSize: '15px',
  lineHeight: '1.75',
  color: 'var(--ink-soft)',
  maxWidth: '56ch',
  margin: '20px auto 0',
  fontWeight: 300,
  textAlign: 'center',
  letterSpacing: '0.04em',
};

export default function LuxeManeStudio() {
  const [tweaks, setTweak] = useTweaks(DEFAULTS);
  const [serviceTab, setServiceTab] = useState("studio");
  const [submitted, setSubmitted] = useState(false);
  const [method, setMethod] = useState(null);

  return (
    <main className={`lms theme-${tweaks.theme}`}>
      <Nav />
      <Hero italic={tweaks.italicAccents} />
      <About italic={tweaks.italicAccents} stamp={tweaks.rotatingStamp} />
      <Services tab={serviceTab} setTab={setServiceTab} italic={tweaks.italicAccents} />
      {tweaks.ribbon && <Ribbon />}
      <Gallery italic={tweaks.italicAccents} />
      <Reviews italic={tweaks.italicAccents} />
      <Contact
        italic={tweaks.italicAccents}
        method={method}
        setMethod={setMethod}
        submitted={submitted}
        setSubmitted={setSubmitted}
      />
      <Footer italic={tweaks.italicAccents} />

      <TweaksPanel title="Tweaks">
        <TweakSection title="Color direction">
          {tweaks.lockTheme && (
            <div style={{
              padding: "8px 10px",
              marginBottom: 10,
              borderRadius: 8,
              background: "rgba(201,133,121,0.10)",
              border: "1px solid rgba(201,133,121,0.35)",
              fontSize: 11,
              letterSpacing: "0.04em",
              color: "inherit",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}>
              <span style={{ fontSize: 12 }}>🔒</span>
              Locked to Blush
            </div>
          )}
          <div style={{
            display: "grid",
            gap: 6,
            opacity: tweaks.lockTheme ? 0.45 : 1,
            pointerEvents: tweaks.lockTheme ? "none" : "auto",
          }}>
            {THEMES.map(t => (
              <button
                key={t.id}
                onClick={() => setTweak("theme", t.id)}
                style={{
                  display: "flex", alignItems: "center", gap: 10,
                  padding: "8px 10px", borderRadius: 8,
                  border: tweaks.theme === t.id ? "1px solid #c98579" : "1px solid rgba(0,0,0,0.1)",
                  background: tweaks.theme === t.id ? "rgba(201,133,121,0.08)" : "transparent",
                  cursor: "pointer", fontSize: 12, color: "inherit", textAlign: "left",
                }}
              >
                <span style={{
                  width: 14, height: 14, borderRadius: "50%",
                  background: t.swatch, border: "1px solid rgba(0,0,0,0.1)",
                }} />
                {t.label}
              </button>
            ))}
          </div>
          <div style={{ marginTop: 10 }}>
            <TweakToggle
              label="Lock to Blush"
              value={tweaks.lockTheme}
              onChange={v => { setTweak("lockTheme", v); if (v) setTweak("theme", "blush"); }}
            />
          </div>
        </TweakSection>
        <TweakSection title="Display">
          <TweakToggle label="Italic accent words" value={tweaks.italicAccents} onChange={v => setTweak("italicAccents", v)} />
          <TweakToggle label="Rotating stamp on portrait" value={tweaks.rotatingStamp} onChange={v => setTweak("rotatingStamp", v)} />
          <TweakToggle label="Decorative ribbon" value={tweaks.ribbon} onChange={v => setTweak("ribbon", v)} />
        </TweakSection>
      </TweaksPanel>
    </main>
  );
}

function Nav() {
  return (
    <header className="lms-nav">
      <div className="lms-container lms-nav-inner">
        <a className="lms-logo" href="#top">
          Luxe Mane
          <small>NYC · Est. 2018</small>
        </a>
        <nav className="lms-links">
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#gallery">Gallery</a>
          <a href="#reviews">Reviews</a>
        </nav>
        <div className="lms-nav-right">
          <a className="lms-cta-pill" href="#contact">Book</a>
        </div>
      </div>
    </header>
  );
}

function Hero({ italic }) {
  return (
    <section id="top" className="lms-hero">
      <div className="lms-container">
        <div className="lms-hero-flourish">
          <span>NYC Hair Atelier</span>
        </div>
        <h1 className="lms-hero-title">
          <span className="row">Custom</span>
          <span className="row">
            {italic ? <span className="it">extensions,</span> : <span>extensions,</span>}
          </span>
          <span className="row">Effortless.</span>
        </h1>
        <p className="lms-hero-sub">
          A private studio dedicated to precision placement, comfort, and long-term hair health. Every install is built around the individual — never templated.
        </p>
        <div className="lms-hero-actions">
          <a className="lms-btn lms-btn-primary" href="#contact">Book a consultation</a>
          <a className="lms-btn lms-btn-text" href="#services">View services →</a>
        </div>

        <div className="lms-hero-floats" aria-hidden="true">
          <div className="lms-hero-float lms-hero-float-l"></div>
          <div className="lms-hero-float lms-hero-float-r"></div>
          <div className="lms-hero-float lms-hero-float-r2"></div>
        </div>

        <div className="lms-hero-meta">
          <div className="lms-hero-meta-item">
            <span className="lms-hero-meta-num">8+</span>
            <span className="lms-hero-meta-label">Years</span>
          </div>
          <div className="lms-hero-meta-item">
            <span className="lms-hero-meta-num">5</span>
            <span className="lms-hero-meta-label">Methods</span>
          </div>
          <div className="lms-hero-meta-item">
            <span className="lms-hero-meta-num">1:1</span>
            <span className="lms-hero-meta-label">Private</span>
          </div>
          <div className="lms-hero-meta-item">
            <span className="lms-hero-meta-num">NYC</span>
            <span className="lms-hero-meta-label">Studio</span>
          </div>
        </div>
      </div>
    </section>
  );
}

function About({ italic, stamp }) {
  return (
    <section id="about" className="lms-section lms-about">
      <div className="lms-about-bloom lms-about-bloom-1"></div>
      <div className="lms-about-bloom lms-about-bloom-2"></div>
      <div className="lms-container">
        <div className="lms-about-grid">
          <div style={{ position: "relative" }}>
            <div className="lms-about-portrait">
              <img src={salon} alt="Studio portrait" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <div className="lms-about-portrait-tag">Studio portrait</div>
            </div>
            {stamp && (
              <div className="lms-about-stamp" aria-hidden="true">
                Hair · Atelier · NYC ·
                <span>luxe</span>
              </div>
            )}
          </div>
          <div>
            <div className="lms-eyebrow">About the studio</div>
            <h2 className="lms-h2">
              Luxury, with{" "}
              {italic ? <span className="it">intention.</span> : <span>intention.</span>}
            </h2>
            <p className="lms-about-quote">
              "A private NYC studio specializing in high-end extensions —{" "}
              {italic
                ? <span className="it">blending, balance, and integrity.</span>
                : <span>blending, balance, and integrity.</span>}"
            </p>
            <p className="lms-about-body">
              Each install is customized to the individual. Method, placement, density, and finish are carefully considered to achieve a natural, effortless result.
            </p>
            <p className="lms-about-body">
              We don't believe in one size fits all. Every appointment is built around you: your hair, your goals, your timeline.
            </p>
            <div className="lms-about-pillars">
              <Pillar icon="✺" title="Consultation led" text="Every install begins with a thorough conversation about your goals." />
              <Pillar icon="◯" title="Precision placement" text="Placed for comfort, longevity, and a seamless blend." />
              <Pillar icon="❋" title="Healthy first" text="Aftercare guidance to keep your hair its strongest." />
              <Pillar icon="✦" title="Color-matched" text="Tones blended in studio for a true-to-you finish." />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Pillar({ icon, title, text }) {
  return (
    <div className="lms-pillar">
      <div className="lms-pillar-icon">{icon}</div>
      <h3 className="lms-pillar-title">{title}</h3>
      <p className="lms-pillar-text">{text}</p>
    </div>
  );
}

function Services({ tab, setTab, italic }) {
  return (
    <section id="services" className="lms-section">
      <div className="lms-container">
        <div className="lms-services-head">
          <div className="lms-eyebrow">Services & Pricing</div>
          <h2 className="lms-h2">
            A considered{" "}
            {italic ? <span className="it">menu.</span> : <span>menu.</span>}
          </h2>
          <p style={leadStyle}>
            Pricing reflects time, technique and customization. Final pricing is confirmed at consultation.
          </p>
          <div className="lms-services-tabs" role="tablist">
            <button
              className={`lms-services-tab ${tab === "studio" ? "is-active" : ""}`}
              onClick={() => setTab("studio")}
            >
              In Studio
            </button>
            <button
              className={`lms-services-tab ${tab === "ext" ? "is-active" : ""}`}
              onClick={() => setTab("ext")}
            >
              Extensions
            </button>
          </div>
        </div>

        {tab === "studio" ? (
          <div className="lms-studio-grid">
            {STUDIO.map(s => (
              <div key={s.id} className="lms-studio-card">
                <div className="lms-studio-card-img">
                  <img src={s.img} alt={s.name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                </div>
                <h3 className="lms-studio-card-name">{s.name}</h3>
                <p className="lms-studio-card-desc">{s.desc}</p>
                <div className="lms-studio-card-meta">
                  <span className="lms-studio-card-price">{s.price}</span>
                  <span className="lms-studio-card-time">{s.time}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="lms-ext-rail">
            {EXTENSIONS.map(e => (
              <div key={e.id} className="lms-ext-card">
                <div className="lms-ext-card-img">
                  <img src={e.img} alt={e.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <h3 className="lms-ext-card-name">{e.name}</h3>
                <p className="lms-ext-card-desc">{e.desc}</p>
                <div className="lms-ext-prices">
                  <div className="lms-ext-price">
                    <span className="lms-ext-price-label">New install</span>
                    <span className="lms-ext-price-value">{e.install}</span>
                  </div>
                  {e.maint && (
                    <div className="lms-ext-price lms-ext-price--maint">
                      <span className="lms-ext-price-label">Maintenance</span>
                      <span className="lms-ext-price-value">{e.maint}</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="lms-services-foot">
          <p className="lms-services-foot-text">
            Not sure which method?{" "}
            {italic ? <span className="it">Let's chat.</span> : <span>Let's chat.</span>}
          </p>
          <a className="lms-btn lms-btn-primary" href="#contact">Inquire for a quote</a>
        </div>
      </div>
    </section>
  );
}

function Ribbon() {
  return (
    <div className="lms-container">
      <div className="lms-ribbon">Soft, blended, undetectable</div>
    </div>
  );
}

function Gallery({ italic }) {
  const VISIBLE = 2;
  const total = GALLERY.length;
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const [transitioning, setTransitioning] = useState(false);
  const timerRef = useRef(null);

  const advance = useCallback((dir) => {
    if (transitioning) return;
    setTransitioning(true);
    setIndex(i => (i + dir + total) % total);
    setTimeout(() => setTransitioning(false), 400);
  }, [transitioning, total]);

  useEffect(() => {
    if (paused) return;
    timerRef.current = setInterval(() => advance(1), 3000);
    return () => clearInterval(timerRef.current);
  }, [paused, advance]);

  const visible = Array.from({ length: VISIBLE }, (_, i) =>
    GALLERY[(index + i) % total]
  );

  return (
    <section id="gallery" className="lms-section lms-gallery-section">
      <div className="lms-container lms-section-center" style={{ marginBottom: '48px' }}>
        <div className="lms-eyebrow">Recent work</div>
        <h2 className="lms-h2">
          Seamless{' '}
          {italic ? <span className="it">blends.</span> : <span>blends.</span>}
        </h2>
        <p style={leadStyle}>
          A selection of recent installs across methods and tones.
        </p>
      </div>

      <div
        className="lms-container"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div className="lms-carousel">
          <div className="lms-carousel-track">
            {visible.map((g, i) => (
              <figure
                key={`${index}-${i}`}
                className="lms-carousel-item"
                style={{ animationDelay: `${i * 60}ms` }}
              >
                <div className="lms-carousel-img">
                  <img src={g.img} alt={g.label} />
                </div>
                <div className="lms-gallery-overlay">
                  <span className="lms-gallery-tag">{g.label}</span>
                </div>
              </figure>
            ))}
          </div>

          <button
            className="lms-carousel-arrow lms-carousel-arrow--prev"
            onClick={() => advance(-1)}
            aria-label="Previous"
          >
            ‹
          </button>
          <button
            className="lms-carousel-arrow lms-carousel-arrow--next"
            onClick={() => advance(1)}
            aria-label="Next"
          >
            ›
          </button>
        </div>

        <div className="lms-carousel-dots">
          {GALLERY.map((_, i) => (
            <button
              key={i}
              className={`lms-carousel-dot ${i === index ? 'is-active' : ''}`}
              onClick={() => { setIndex(i); setTransitioning(false); }}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function Reviews({ italic }) {
  return (
    <section id="reviews" className="lms-section">
      <div className="lms-container lms-section-center">
        <div className="lms-eyebrow">In their words</div>
        <h2 className="lms-h2">
          Clients return for the{" "}
          {italic ? <span className="it">detail.</span> : <span>detail.</span>}
        </h2>
      </div>
      <div className="lms-container">
        <div className="lms-reviews-grid">
          {REVIEWS.map((r, i) => (
            <div key={i} className="lms-review">
              <div className="lms-review-quote-mark">"</div>
              <p className="lms-review-quote">{r.quote}</p>
              <div className="lms-review-foot">
                <div className="lms-review-author">
                  <div className="lms-review-avatar">{r.initials.charAt(0)}</div>
                  <div className="lms-review-name">
                    {r.initials}
                    <small>{r.location} · {r.method}</small>
                  </div>
                </div>
                <span className="lms-review-stars">★★★★★</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Contact({ italic, method, setMethod, submitted, setSubmitted }) {
  const methods = ["Tape Ins", "Hand-Tied Weft", "K-Tips", "I-Tips", "Clip Ins", "Not sure"];
  const [contactPref, setContactPref] = useState(null);
  const handle = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
  };
  return (
    <section id="contact" className="lms-section lms-contact-section">
      <div className="lms-about-bloom lms-about-bloom-1"></div>
      <div className="lms-about-bloom lms-about-bloom-2"></div>
      <div className="lms-container lms-section-center">
        <div className="lms-eyebrow">Begin</div>
        <h2 className="lms-h2">
          Request a{" "}
          {italic ? <span className="it">consultation.</span> : <span>consultation.</span>}
        </h2>
        <p style={leadStyle}>
          Share your hair goals, current photos if available, and general availability. You'll be guided to the most suitable option.
        </p>
      </div>
      <div className="lms-container">
        <form className="lms-contact-card" onSubmit={handle}>
          <div className="lms-form">
            <div className="lms-field-row">
              <label className="lms-field">
                <span className="lms-field-label">Name</span>
                <input className="lms-field-input" type="text" placeholder="Your name" />
              </label>
              <label className="lms-field">
                <span className="lms-field-label">Email</span>
                <input className="lms-field-input" type="email" placeholder="you@email.com" />
              </label>
            </div>
            <div className="lms-field-row">
              <label className="lms-field">
                <span className="lms-field-label">Phone</span>
                <input className="lms-field-input" type="tel" placeholder="(212) 000-0000" />
              </label>
            </div>
            <div className="lms-field">
              <span className="lms-field-label">Preferred method of contact</span>
              <div className="lms-chips">
                {["Email", "Phone", "Text"].map(c => (
                  <button
                    type="button"
                    key={c}
                    className={`lms-chip ${contactPref === c ? "is-active" : ""}`}
                    onClick={() => setContactPref(contactPref === c ? null : c)}
                  >{c}</button>
                ))}
              </div>
            </div>
            <div className="lms-field">
              <span className="lms-field-label">Method of interest</span>
              <div className="lms-chips">
                {methods.map(m => (
                  <button
                    type="button"
                    key={m}
                    className={`lms-chip ${method === m ? "is-active" : ""}`}
                    onClick={() => setMethod(method === m ? null : m)}
                  >
                    {m}
                  </button>
                ))}
              </div>
            </div>
            <label className="lms-field">
              <span className="lms-field-label">Tell us about your hair</span>
              <textarea className="lms-field-textarea" rows={4} placeholder="Goals, current condition, timing..."></textarea>
            </label>
            <div className="lms-form-foot">
              <button type="submit" className="lms-btn lms-btn-primary">Send inquiry</button>
            </div>
            {submitted && (
              <div className="lms-form-success">Inquiry received — we'll be in touch within 48 hours.</div>
            )}
          </div>
        </form>
      </div>
    </section>
  );
}

function Footer({ italic }) {
  return (
    <footer className="lms-footer">
      <div className="lms-container">
        <div className="lms-footer-mark">
          Luxe {italic ? <span className="it">mane</span> : <span>mane</span>}.
        </div>
        <div className="lms-footer-grid">
          <div>
            <h4>Studio</h4>
            <div className="lms-footer-col">
              <a href="#about">About</a>
              <a href="#services">Services</a>
              <a href="#gallery">Gallery</a>
            </div>
          </div>
          <div>
            <h4>Methods</h4>
            <div className="lms-footer-col">
              <a href="#services">Tape Ins</a>
              <a href="#services">Hand-Tied Weft</a>
              <a href="#services">K-Tips · I-Tips</a>
              <a href="#services">Clip Ins</a>
            </div>
          </div>
          <div>
            <h4>Visit</h4>
            <div className="lms-footer-col">
              <span>Private NYC</span>
              <span>Tue – Sat</span>
              <span>By appointment</span>
            </div>
          </div>
          <div>
            <h4>Connect</h4>
            <div className="lms-footer-col">
              <a href="mailto:studio@luxemane.nyc">studio@luxemane.nyc</a>
              <a href="https://instagram.com/luxemane.studio">@luxemane.studio</a>
              <a href="https://pinterest.com">Pinterest</a>
            </div>
          </div>
        </div>
        <div className="lms-footer-bottom">
          <span>© {new Date().getFullYear()} Luxe Mane Studio</span>
          <a href="#top">Back to top ↑</a>
        </div>
      </div>
    </footer>
  );
}